export default __webpack_public_path__ + "static/media/logo.c577d267.png";